import React from 'react';
import {
    withStyles,
    IconButton,
} from '@material-ui/core';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { withRouter } from 'react-router-dom';
import AppData from '../../model/AppData';
import AppUtils from '../../control/apputlis';

class MBackIcon extends React.Component {

    constructor(props) {
        super(props);
        this._onBackClick = this._onBackClick.bind(this);
    }

    componentWillUnmount() {
        this.backTimeOut && clearTimeout(this.backTimeOut);
    }

    _onBackClick() {
        console.log('_onBackClick')

        
        let match_type = AppUtils.getQueryVariable('match_type');
        let match_id = AppUtils.getQueryVariable('match_id');

        if (match_type && match_id) {
            return window.location.replace('/')
        }

        if (AppData.os == '' || AppData.os == '0' || AppData.os == 'h5') {
            window.history.back();
        } else {
            window.webkit.messageHandlers.VCBack.postMessage('');
        }
    }

    render() {
        const { classes, className, style } = this.props;
        return (
            <IconButton
                style={style ? style : { position: 'absolute', left: 16, color: this.props.appBarColor == '#FC4545' ? '#FFF' : '#0D0D0D' }}
                edge="start"
                color='default'
                className={className ? className : classes.root}
                onClick={() => this._onBackClick()}
                aria-label="close">
                <ArrowBackIosIcon style={{ fontSize: '1.3rem', }} />
            </IconButton>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        color: '#0D0D0D'
    }
}))(MBackIcon));